export const caseStudiesIndex = {
  eyebrow: 'Case Studies',
  heading: 'Systems we shipped, and what happened after.',
  tagline: 'The problem going in, the system we built, and the outcome once it was live in production. Some clients are named; some asked not to be. The build details stay the same either way.',
  backLinkLabel: 'Back to Case Studies',
  emptyState: 'No case studies published yet.',
  filterAll: 'All work',
  typeLabels: {
    client: 'Client systems',
    tool: 'Studio tools',
    product: 'Products',
    experiment: 'Experiments',
  },
  outcomeLabel: 'Outcome',
  onThisPage: 'On this page',
  factsTitle: 'At a glance',
  factLabels: {
    client: 'Client',
    type: 'Type',
    date: 'Published',
    readTime: 'Read time',
    stack: 'Stack',
  },
  faqHeading: 'Questions we get about this build',
  prevNext: {
    heading: 'More case studies',
    newer: 'Newer',
    older: 'Older',
  },
  cta: {
    heading: 'Have a process that should run itself?',
    body: 'Bring the messiest workflow you have. We will tell you what to automate, what to leave manual, and when an agent is the wrong answer.',
    button: 'Talk to Merlin',
  },
};
